export default __webpack_public_path__ + "static/EcoswimV2_NEW-Box-13197843d9dfbb8bb5cef01c0de05f5c.png";